"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));
const FormHelperText_1 = __importDefault(require("@material-ui/core/FormHelperText"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Input_1 = __importDefault(require("@material-ui/core/Input"));
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
const InputLabel_1 = __importDefault(require("@material-ui/core/InputLabel"));
const AddPhotoAlternate_1 = __importDefault(require("@material-ui/icons/AddPhotoAlternate"));
const Delete_1 = __importDefault(require("@material-ui/icons/Delete"));
const ImageSearch_1 = __importDefault(require("@material-ui/icons/ImageSearch"));
const react_1 = __importStar(require("react"));
const lib_1 = require("../../../lib");
const context_1 = __importDefault(require("../context"));
const styles_1 = __importDefault(require("../styles"));
const InputImage = ({ name, label, type, autoFocus = false, required = false, disabled = false, hasError, message, }) => {
    const { obj, updateProperty } = react_1.useContext(context_1.default);
    const classes = styles_1.default();
    const [selectedFileName, setSelectedFileName] = react_1.useState(lib_1.deepGet(obj, `${name}.fileName`, ''));
    const [thumbnail, setThumbnail] = react_1.useState(lib_1.deepGet(obj, `${name}.thumbnail`, undefined));
    const fileReader = react_1.useMemo(() => new FileReader(), []);
    react_1.useEffect(() => {
        fileReader.onload = function () {
            setThumbnail(fileReader.result);
        };
    }, [fileReader]);
    function onFileSelected({ target: { files }, }) {
        if (!files || !files[0])
            return;
        const file = files[0];
        setSelectedFileName(file.name);
        fileReader.readAsDataURL(file);
        updateProperty(name, type)(file);
    }
    function clearField(e) {
        e.stopPropagation();
        e.preventDefault();
        setSelectedFileName('');
        setThumbnail(undefined);
        updateProperty(name, type)(null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", { accept: "image/*", style: { display: 'none' }, id: `${name}-hidden`, type: "file", onChange: onFileSelected }),
        react_1.default.createElement("label", { htmlFor: `${name}-hidden` },
            react_1.default.createElement(FormControl_1.default, { fullWidth: true, margin: "dense" },
                react_1.default.createElement(InputLabel_1.default, { htmlFor: name, error: hasError }, label + (required ? ' *' : '')),
                react_1.default.createElement(Input_1.default, { id: name, type: "text", disabled: disabled, autoFocus: autoFocus, required: required, value: selectedFileName, startAdornment: react_1.default.createElement(InputAdornment_1.default, { position: "start", className: classes.thumbnailWrapper }, thumbnail ? (react_1.default.createElement("img", { src: thumbnail, alt: `${name}-thumbnail`, className: classes.thumbnail })) : (react_1.default.createElement(AddPhotoAlternate_1.default, { fontSize: "large" }))), endAdornment: react_1.default.createElement(InputAdornment_1.default, { position: "end" },
                        react_1.default.createElement(Button_1.default, { component: "span" },
                            react_1.default.createElement(ImageSearch_1.default, { className: classes.iconLeft }),
                            "Browse"),
                        selectedFileName && (react_1.default.createElement(IconButton_1.default, { "aria-label": "Remove selected image", onClick: clearField },
                            react_1.default.createElement(Delete_1.default, null)))), inputProps: {
                        disabled: true,
                    }, error: hasError, "aria-describedby": `${name}-helper` }),
                hasError && (react_1.default.createElement(FormHelperText_1.default, { id: `${name}-helper`, error: true }, message))))));
};
exports.default = InputImage;
//# sourceMappingURL=Image.js.map